var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4687 4.59571C12.3901 4.35272 12.1746 4.18014 11.9196 4.15716L8.45612 3.84266L7.08655 0.637008C6.98556 0.402075 6.75558 0.25 6.50005 0.25C6.24452 0.25 6.01453 0.402075 5.91355 0.637557L4.54398 3.84266L1.07991 4.15716C0.825385 4.18069 0.610414 4.35272 0.531402 4.59571C0.45239 4.8387 0.525359 5.10522 0.717899 5.27323L3.33591 7.56927L2.56392 10.9699C2.50743 11.22 2.60448 11.4784 2.81194 11.6284C2.92346 11.709 3.05392 11.75 3.18549 11.75C3.29892 11.75 3.41144 11.7194 3.51243 11.659L6.50005 9.87337L9.48657 11.659C9.70511 11.7905 9.9806 11.7785 10.1876 11.6284C10.3952 11.478 10.4921 11.2194 10.4356 10.9699L9.66364 7.56927L12.2816 5.27368C12.4742 5.10522 12.5477 4.83916 12.4687 4.59571Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar3);
export default __webpack_public_path__ + "static/media/star3.0209ae93001582c4ee0aedf67648a7f6.svg";
export { ForwardRef as ReactComponent };